import { queryClient } from "@data/lib";
import { initializeAnalytics } from "@mod/core/config/initialize-analytics";
import * as Sentry from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";
import dayjs from "dayjs";
import "dayjs/locale/es";
import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { LanguageProvider } from "./context";
import "./main.css";
import { getAppRouter } from "./routes/router";

dayjs.locale("es");

if (process.env.NODE_ENV != "development") {
  Sentry.init({
    dsn: "https://e5cf8491340e7f3a146ca10c641e40c5@o1062629.ingest.us.sentry.io/4508919934615552",
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

const Root = () => {
  useEffect(() => {
    initializeAnalytics();
  }, []);
  return (
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <RouterProvider router={getAppRouter()} />
      </LanguageProvider>
    </QueryClientProvider>
  );
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
